export enum ModalTipoEnum {
  GUARDAR = 'Guardar',
  RESTAURAR = 'Restaurar',
  SALIR = 'Salir',
}
